import React from 'react';
import PropTypes from 'prop-types';
import { HereMapContext } from './here-map-context';
import * as HereMapRouteService from '../../services/here-maps/here-map-route-service';
import * as HereMapWrapper from '../../services/here-maps/here-map-wrapper';
import { MAP_LINE_Z_INDEX } from '../../constants/constants';
import { HereMapColors } from '../../styles/agistics-colors';
import { useCompanyId } from '../../app/agistics-context';
import axios from 'axios';

export const HereMapRoute = (props) => {
    // props.green - true if for smart trailer
    const companyId = useCompanyId();
    const [polyline, setPolyline] = React.useState(null);
    const context = React.useContext(HereMapContext);
    const map = React.useRef();
    const polylineId = React.useRef();
    const previousWaypoints = React.useRef('');

    React.useEffect(() => {
        return () => {
            const existingRoute = map.current?.getObjects()
                .find(obj => obj.getId() === polylineId.current);

            if (existingRoute) {
                map.current.removeObject(existingRoute);
            }
        };
    }, []);

    React.useEffect(() => {
        if (!context.map) {
            setPolyline(null);
            return;
        }
        map.current = context.map;

        if (props.calculateRouteFromWaypoints && JSON.stringify(props.waypoints) !== previousWaypoints.current) {
            previousWaypoints.current = JSON.stringify(props.waypoints);

            const postPayload = {
                stops: props.waypoints,
                ...(props.equipmentWeight ? {equipmentWeight: props.equipmentWeight} : {})
            }
            axios.post(`${API_BASE}/api/organizations/${companyId}/routing`, postPayload).then((response) => {
                if (response.data) {
                    const sections = response.data.routes[0].sections;
                    const lineStrings = [];
                    sections.forEach((section) => {
                        lineStrings.push(HereMapWrapper.lineStringFromEncodedPolyline(section.polyline));
                    });

                    //convert to MultiLineString as it's a format compatable with H.map.Polyline
                    const multiLineString = HereMapWrapper.createMultiLineString(lineStrings);
                    setRoute(multiLineString, HereMapColors.CALCULATED_ROUTE);
                }
            });
        } else if (!props.calculateRouteFromWaypoints && JSON.stringify(props.waypoints) !== previousWaypoints.current) {
            previousWaypoints.current = JSON.stringify(props.waypoints);

            const positions = HereMapWrapper.createLineString(props.waypoints.flat());
            setRoute(positions, props.green ? HereMapColors.SMART_TRAILER : HereMapColors.ACTIVE, true);
        }
    }, [props.waypoints, context]);

    const setRoute = (multiLineString, color, actualRoute = false) => {
        const newPolyline = HereMapWrapper.createPolyline(multiLineString, {
            style: {
                lineWidth: 4,
                strokeColor: color,
            },
            zIndex: actualRoute ? MAP_LINE_Z_INDEX.ActualRoute : MAP_LINE_Z_INDEX.CalculatedRoute,
            data: {
                isMobileLocations: actualRoute && !props.green ? true : false,
                isTrailerLocations: actualRoute && props.green ? true : false,
                loadId: props.loadId,
            }
        });

        if (!polyline) {
            setPolyline(newPolyline);
            polylineId.current = newPolyline.getId();

            if (props.pointerEvents) {
                newPolyline.addEventListener('pointerenter', (evt) => {
                    props.pointerEvents.onMouseEnter();
                }, true);

                newPolyline.addEventListener('pointerleave', (evt) => {
                    props.pointerEvents.onMouseLeave();
                }, true);
            }

            // Add the polyline to the map
            context.map.addObject(newPolyline);
        } else {
            polyline.setGeometry(multiLineString);
        }

        props.onRouteDrawn && props.onRouteDrawn();
    };

    return null;
};

HereMapRoute.propTypes = {
    calculateRouteFromWaypoints: PropTypes.bool,
    onRouteDrawn: PropTypes.func,
    waypoints: PropTypes.array,
    equipmentWeight: PropTypes.number,
    avoidanceZones: PropTypes.array,
    green: PropTypes.bool,
    loadId: PropTypes.number,
    pointerEvents: PropTypes.object,
};
